export const ERROR_NAME = 'AttensiFetchError'
